<p-card>
  <ng-template pTemplate="header">
    <div class="p-card-title">
      {{ service.title() }}
    </div>
    <p-buttonGroup>
      @if (!detailed()) {
        <button
          pButton
          pRipple
          [label]="'Detalles'"
          icon="pi pi-info-circle"
          [title]="'Contract List Details'"
          (click)="routesService.list(resource)"
          class="p-button start"></button>
      }
      @if (access()?.contract?.actions?.create) {
        <button
          pButton
          pRipple
          [label]="'Nuevo'"
          icon="pi pi-user-plus"
          [title]="'Crate Contract'"
          (click)="routesService.create(resource)"
          class="p-button end"></button>
      }
    </p-buttonGroup>
  </ng-template>
  @defer (when value()) {
    <p-table
      [value]="value()"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="name" class="min-w-52">
            Nombre <p-sortIcon field="name" />
          </th>
          @if (detailed()) {
            <th class="min-w-52">
              Descripción
            </th>
            <th pSortableColumn="phone" class="min-w-52">
              Teléfono <p-sortIcon field="phone" />
            </th>
            <th pSortableColumn="website" class="min-w-32">
              Sitio Web <p-sortIcon field="website" />
            </th>
            <th pSortableColumn="address" class="min-w-32">
              Dirección <p-sortIcon field="address" />
            </th>
          }
          <th class="action">
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
        <tr>
          <td class="max-w-min">{{ value.name }}</td>
          @if (detailed()) {
            <td>{{ value.description ?? 'Este contrato no tiene descripción' }}</td>
            <td>{{ value.phone ?? 'Este contrato no tiene numero telefonico' }}</td>
            <td>{{ value.website ?? 'Este contrato no tiene sitio web' }}</td>
            <td>{{ value.address ?? 'Este contrato no tiene dirección' }}</td>
          }
          <td>
            <p-buttonGroup>
              <button
                pButton
                pRipple
                icon="pi pi-info-circle"
                [title]="value.name + ' details'"
                (click)="routesService.details(resource, value._id)">
              </button>
              @if (access()?.contract?.actions?.update) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-user-edit"
                  [title]="value.name + ' edit'"
                  (click)="routesService.edit(resource, value._id)">
                </button>
              }
              @if (access()?.contract?.actions?.delete) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  [title]="value.name + ' delete'"
                  (click)="routesService.delete(resource, value._id)">
                </button>
              }
            </p-buttonGroup>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</p-card>
